import Vue from 'vue'
import { format, parseISO } from 'date-fns'
import { es } from 'date-fns/locale'

// Used in CoordinatorNoteModal.vue
Vue.filter('formatDateNote', function (value) {
  if (value) {
    let date = parseISO(String(value).trim())
    return format(date, "EEEE, d MMM", { locale: es })
  }
})
